import { Link } from "react-router-dom";
import { Lock, Handshake, Eye, TrendingUp, Search } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const fmtFjd = (n) => {
    const num = Math.round(n || 0);
    return `FJ$${new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(num)}`;
};

export default function ListingRow({ listing, onConvert, onVisibility, onMatches }) {
    const isConverted = !!listing.converted_to_jv_id;
    const isOff = !!listing.is_off_market;
    return (
        <Card className="p-4 lg:p-5 bg-card hover:border-coral/40 transition" data-testid={`agent-listing-${listing.id}`}>
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                        <Link to={`/listings/${listing.id}`} className="font-display text-base font-bold text-foreground hover:text-coral transition truncate">
                            {listing.title}
                        </Link>
                        {isOff && (
                            <Badge variant="outline" className="text-[10px] border-coral/40 text-coral">
                                <Lock className="h-2.5 w-2.5 mr-1" /> Off-market
                            </Badge>
                        )}
                        {isConverted && (
                            <Badge variant="outline" className="text-[10px] border-fiji-green/40 text-fiji-green">
                                <Handshake className="h-2.5 w-2.5 mr-1" /> JV active
                            </Badge>
                        )}
                        {listing.commission_split_pct ? (
                            <Badge variant="outline" className="text-[10px] border-muted-foreground/30 text-muted-foreground">
                                Split {listing.commission_split_pct}%
                            </Badge>
                        ) : null}
                    </div>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-app text-muted-foreground">
                        <span>{listing.location_region}, {listing.location_island}</span>
                        <span>·</span>
                        <span className="font-semibold text-foreground tabular-nums">{fmtFjd(listing.price_fjd)}</span>
                        <span>·</span>
                        <span><Eye className="h-3 w-3 inline mr-0.5" />{listing.views || 0} views</span>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2">
                    <Button
                        size="sm"
                        variant="outline"
                        onClick={onMatches}
                        data-testid={`agent-listing-matches-${listing.id}`}
                        className="font-app border-fiji-green/40 text-fiji-green hover:bg-fiji-green/10"
                    >
                        <Search className="h-3.5 w-3.5 mr-1.5" /> Who's looking?
                    </Button>
                    {!isConverted && (
                        <Button
                            size="sm"
                            onClick={onConvert}
                            data-testid={`agent-listing-convert-${listing.id}`}
                            className="bg-coral hover:bg-coral-deep text-white font-app"
                        >
                            <TrendingUp className="h-3.5 w-3.5 mr-1.5" /> Convert to JV
                        </Button>
                    )}
                    <Button
                        size="sm"
                        variant="outline"
                        onClick={onVisibility}
                        data-testid={`agent-listing-visibility-${listing.id}`}
                        className="font-app"
                    >
                        <Lock className="h-3.5 w-3.5 mr-1.5" /> Visibility
                    </Button>
                </div>
            </div>
        </Card>
    );
}
